import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/chu-de-mua.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@fontsource/inter/300.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@fontsource/inter/400.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@fontsource/inter/500.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@fontsource/inter/600.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@fontsource/inter/700.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@fontsource/poppins/400.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@fontsource/poppins/500.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@fontsource/poppins/600.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@fontsource/poppins/700.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@fontsource/nunito/700.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@fontsource/nunito/800.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@fontsource/jetbrains-mono/400.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@fontsource/jetbrains-mono/500.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@fontsource-variable/fraunces/opsz.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/admin/MfaStepUpDialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/analytics/PageViewTracker.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/chat/FloatingAIAssistant.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/chuDeMua/ChuDeMuaHost.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/doiKhang/LoiMoiDoiKhang.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/language/LangReviewReminder.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/nav/SiteNav.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/music/GlobalMusicPlayer.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/music/ListenTogetherSync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/music/MusicAudioController.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/music/MusicHistoryRecorder.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/notes/QuickCaptureHost.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/pro/ProExpiryReminder.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/providers/AmThanhUiHost.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/providers/AuthBoot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/providers/AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/providers/BaoHoatDong.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/providers/ClientOnly.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/providers/LocaleWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/providers/PWAInstallPrompt.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/providers/ServiceWorkerRegister.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/providers/SoundInitializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/providers/TanStackQueryProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/providers/ToasterProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/shop/CartDrawer.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/social/AnnouncementBotPopup.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/social/PostCommentModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/AppBootSplash.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/src/context/ThemeContext.tsx");
